import { CampaignTypesTable } from 'entities/campaign';
import type { CampaignHistoryEventTypes } from 'entities/history';
import type { BadgeProps } from 'shared/ui/Badge';

export const CAMPAIGN_EDITING_DISABLED_MESSAGE =
  'Campaign details editing is disabled until 8:00 AM EST Monday. Please contact your Manager with any questions.';
export const WEEKLY_BUDGET_INFO_MESSAGE =
  'A weekly budget is used to regulate volume. Please note that a budget increase will take effect immediately while a budget decrease will go into effect the following Monday.';

export const CAMPAIGN_HISTORY_EVENTS_BADGE_PROPS: Record<CampaignHistoryEventTypes, BadgeProps> = {
  campaign_created: { text: 'Campaign created', color: 'deepBlue', size: 'lg' },
  campaign_status_updated: { text: 'Status updated', color: 'deepGreen', size: 'lg' },
  campaign_is_active_updated: { text: 'Status updated', color: 'deepGreen', size: 'lg' },
  campaign_pausing_reason_updated: { text: 'Status updated', color: 'deepGreen', size: 'lg' },
  campaign_name_updated: { text: 'Name updated', color: 'deepGreen', size: 'lg' },
  campaign_budget_updated: { text: 'Budget updated', color: 'magenta', size: 'lg' },
  campaign_schedule_updated: { text: 'Schedule updated', color: 'orange', size: 'lg' },
  campaign_calendar_url_updated: { text: 'Calendar Url updated', color: 'yellow', size: 'lg' },
  campaign_minimal_income_updated: { text: 'Minimal income updated', color: 'red', size: 'lg' },
  campaign_target_area_updated: { text: 'Target area updated', color: 'slate', size: 'lg' },
  campaign_bid_updated: { text: 'Bid updated', color: 'mint', size: 'lg' },
  integration_created: { text: 'Integration created', color: 'deepGreen', size: 'lg' },
  integration_updated: { text: 'Integration updated', color: 'deepGreen', size: 'lg' },
  integration_deleted: { text: 'Integration deleted', color: 'deepGreen', size: 'lg' },
  test_crm_request: { text: 'Test lead sent', color: 'orange', size: 'lg' },
};

export const companyTypesOptions = [
  { text: CampaignTypesTable.lead, id: 'lead' },
  { text: CampaignTypesTable.appt, id: 'appt' },
  { text: CampaignTypesTable.sales, id: 'sales' },
];
